/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import Hidden from "@material-ui/core/Hidden";

import "../reportView.css";
import { Redirect } from "react-router-dom";
import { routes } from "../../../../routing/routes";
import { templateStrings } from "../../../../Constant";
import { BarLoader } from "../../../../shared/widgets";
import { TableWrapper, PageWrapper } from "../../../../shared/layout";
import { selectDateFilter } from "../../../../redux/actions/dateFilterAction";
import { distanceReportAction } from "../../../../redux/action-creators/distanceReportActionCreator";
import { handleDatesChange } from "../../../../shared/utils";
import ButtonToolbarRangePicker from "../../../../shared/components/commonComponents/ButtonToolbarRangePicker";

class DistanceReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      totalPages: 0,
      sortBy: "",
      selected: [],
      showUploadXlsxModal: false,
    };
  }

  componentDidMount() {
    this.distanceReportGetList();
  }

  componentDidUpdate(prevProps) {
    const { cityFilter, operatorFilter, dateFilter } = this.props;
    if (
      (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
      || (prevProps && prevProps.dateFilter !== dateFilter)
    ) {
      this.distanceReportGetList();
    }
  }

  // onSortToggle = (value, key) => {
  //   this.setState({ sortBy: { [key]: value } }, () => {
  //     this.distanceReportGetList();
  //   });
  // };

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.distanceReportGetList();
      }
    });
  };

  handleAction = (details) => {
    const { history } = this.props;
    const { monthYear = "" } = details;
    const [, year] = monthYear.split("'");
    const month = new Date(monthYear).getMonth() + 1;
    history?.push("/report/distance/distance-report-details", {
      ...details,
      _fromDate: `${month}/${new Date(`20${year}`).getDate()}/20${year}`,
      _toDate: `${month}/${new Date(
        `20${year}`,
        new Date(monthYear).getMonth() + 1,
        0,
      ).getDate()}/20${year}`,
    });
  };

  distanceReportGetList = () => {
    const {
      distanceReportFetched, dateFilter, cityFilter, operatorFilter,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    distanceReportFetched(
      {
        pageNo,
        pageSize: rowsPerPage,
        dateFilter,
        cityFilter,
        operatorFilter,
        sortBy,
      },
      "header",
    );
  };

  render() {
    const {
      headerLoader, content, totalItems, selectedReports, location, dateFilter,
    } = this.props;
    const {
      pageNo, rowsPerPage, sortBy, selected,
    } = this.state;
    const templateString = templateStrings.reportDistance;
    const redirectRoute = routes.MOBILE_TICKET_REPORT;
    return (
      <div className="pageContainer">
        {selectedReports === "mobileTickets" && (
          <Redirect
            to={{
              pathname: redirectRoute,
              state: { from: location },
            }}
          />
        )}
        <PageWrapper>
          <PageWrapper.Header heading="Distance" hideS>
            <Hidden only={["sm", "xs"]}>
              <div className="pull-right z-index-10">
                <ButtonToolbarRangePicker
                  handleDatesChange={(dates) => handleDatesChange({ dates, props: this.props })}
                  fromDate={dateFilter.fromDate}
                  toDate={dateFilter.toDate}
                />
              </div>
            </Hidden>
          </PageWrapper.Header>
          <PageWrapper.Body>
            <BarLoader scope="header" />
            <TableWrapper
              content={!headerLoader && content}
              pageNo={pageNo}
              selected={selected}
              uniqueKey="uniqKey"
              rowsPerPage={rowsPerPage}
              count={totalItems}
              handleChange={this.handleChange}
              templateString={templateString}
              selectionAllowed={false}
              // onSortToggle={this.onSortToggle}
              sortBy={sortBy}
              handleAction={this.handleAction}
            />
          </PageWrapper.Body>
        </PageWrapper>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    content:
      (state
        && state.Report
        && state.Report.distanceReportData
        && state.Report.distanceReportData.items)
      || [],
    totalItems:
      (state
        && state.Report
        && state.Report.distanceReportData
        && state.Report.distanceReportData.totalItems)
      || 0,
    headerLoader: state && state.loadingBar && state.loadingBar.header,
    dateFilter: state.DateFilter.selectedDateFilter,
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
    selectedReports: state.ReportsType.selectedReportsType,
  };
}

const mapDispatchToProps = (dispatch) => ({
  distanceReportFetched: (params, loaderScope) => {
    dispatch(distanceReportAction(params, loaderScope));
  },
  selectDateFilter: (value) => {
    dispatch(selectDateFilter(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DistanceReport);
